/**
 * preauth-aware-router-link.directive.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Directive, HostListener, Input } from "@angular/core";
import { AuthService } from "./auth.service";

/**
 * The {@link PreauthAwareRouterLink} is an extension to standard routerLinks
 * that can handle
 */
@Directive({selector: "a[routerLink][preauthNewTabs]"})
export class PreauthAwareRouterLink
{
  // NOTE: To avoid the complication of generating relative-/command-based-URL
  // trees (and externalizing them), this directive for now only supports
  // "standard" absolute app URLs. Other URLs will likely be misinterpreted
  // within the new tab because they are passed to a naive router.navigate(...)
  @Input() private routerLink : string;

  constructor (private auth : AuthService) {}

  @HostListener("click", ["$event.button", "$event.ctrlKey", "$event.metaKey"])
  public onClick (button : number, ctrlKey : boolean, metaKey : boolean)
    : boolean
  {
    if (button !== 0 || ctrlKey || metaKey) {
      this.metaClick();
      return false; // cancel the default navigation
    }
  }

  private metaClick () : void
  {
    this.auth.openPreauthedTab(this.routerLink);
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/auth/preauth-aware-router-link.directive.ts